import React from 'react'
import './index.scss'
import { TableHeader } from '@Components/ViewWork/Table'

const Header = ({ row, removableCells }: TableHeader) => (
    <div className="table-header">
        {row.map((heading, index) => (
            <div className="table-header-cell" key={index}>
                {heading.text}
                {heading.tooltip && heading.tooltip}
            </div>
        ))}
        {removableCells && <div className="remove-cell-header">Remove</div>}
    </div>
)

export default Header
